import { Route, Routes } from 'react-router-dom';
import MentorListPage from './list';

export default function MentorRouting() {
  return (
    <Routes>
      <Route index element={<MentorListPage />} />
    </Routes>
  );
}
